import React from "react";
import why_choose_us from "../assets/Why_Choose_us.jpg";
import team_member_1 from "../assets/Vikram_Maheshwari.jpg";
import team_member_2 from "../assets/Sonu_Kabra.jpg";
import team_member_3 from "../assets/mystery-man.png"; 
import plan from "../assets/plan.png";
import execute from "../assets/execute.png";
import manage from "../assets/manage.png";
import clients from "../assets/clients.png";
import aum from "../assets/aum.png";
import experience from "../assets/years.png";
import awards from "../assets/awards.png";
import "./About_knowmore.css";
import whatWeOffer from "../assets/whatweoffer.jpg";

const AboutUsKnowMore = () => {
  return (
    <div className="about-us-container">
      {/* Breadcrumb Navigation */}
      <div className=" breadcrumb-container">
        <p>
          <a href="/">Home</a> / About Us
        </p>
      </div>

      {/* Welcome Section */}
      <div className="header-section">
        <h1>WELCOME TO TAX O WEALTH</h1>
        <p>
          We as Partner firm incorporated in the year 2014 and at present having
          thousands of satisfied clients. We will help clients to achieve their
          Financial goals with effective and smart investment planning. We are
          certified Wealth Manager, Mutual Fund, and Insurance consultants
          recognized by the NSE National Stock Exchange, AMFI (Association of
          Mutual Fund of India). We offer comprehensive financial advisory
          services, having highly qualified and experienced team of financial
          advisors. We use our complete knowledge of insurance, tax laws, and
          mutual fund investments to suggest investment options to the clients,
          as per their long-term and short-term goals. Our core purpose is to
          provide fast track financial solutions & thereby make people enjoy a
          secured retirement life.
        </p>
      </div>

      {/* Why Choose Us Section */}
      <div className="why-choose-us">
        <h2>WHY CHOOSE US?</h2>
        <div className="why-choose-us-content">
          <div className="why-choose-us-image">
            <img src={why_choose_us} alt="Why Choose Us" />
          </div>
          <div className="why-choose-us-details">
            <p>
              Why should Tax O Wealth be your financial advisors/product
              distributors? This is a very relevant question to ask us. And
              given below is our answer...
            </p>
            <ul>
              <li>
                <b>Client-Centric Approach:</b> All our offerings are designed
                keeping you in mind. Your long-term interests serve as the
                "primary" influencing factor in our recommendation process.
              </li>
              <li>
                <b>Rich Product Basket:</b> We offer a single-point access to
                multiple financial products with a holistic need-driven approach
                & not product-centric approach.
              </li>
              <li>
                <b>Focus on Customer Gratification:</b> We ensure higher levels
                of satisfaction and quick resolution of any queries or
                complaints.
              </li>
              <li>
                <b>Value Added Services:</b> Our Services ensure comfort,
                convenience, confidence, and control in managing your wealth.
              </li>
              <li>
                <b>Right Experience & Skills:</b> With over 10+ years of
                experience in financial product distribution space, we offer you
                the right strategies & solutions to achieve your goals.
              </li>
              <li>
                <b>Driven by Passion:</b> Serving clients is our passion 
                and the reason why we are in the business. Nothing excites 
                us more than helping our clients achieve their financial goals and dreams in life.
              </li>
             
            </ul>
          </div>
        </div>
      </div>

      {/* What We Offer Section */}
      <section className="what-we-offer">
      {/* Left Side Content */}
      <div className="text-content">
        <h2 className="offer-title">WHAT WE OFFER</h2>
        <p className="offer-description">
          Purchase of any financial products without consulting a financial planner is like taking medicine without a 
          doctor’s diagnosis. We offer expert advice for choosing the best investment products that will lead to your financial freedom.
        </p>

        <div className="offer-item">
          <img src={plan} alt="Plan" />
          <div>
            <h3 className="offer-item-title">PLAN</h3>
            <p className="offer-item-text">Get customized advice across investments, goals, expenses, insurance, loans, estate planning, and taxes.</p>
          </div>
        </div>

        <div className="offer-item">
          <img src={execute} alt="Execute" />
          <div>
            <h3 className="offer-item-title">EXECUTE</h3>
            <p className="offer-item-text">Implement your customized advice by buying all the recommended financial products on one single platform.</p>
          </div>
        </div>

        <div className="offer-item">
          <img src={manage} alt="Manage" />
          <div>
            <h3 className="offer-item-title">MANAGE</h3>
            <p className="offer-item-text">Track your journey and rebalance your investments to make sure they are aligned with your goals.</p>
          </div>
        </div>
      </div>

      {/* Right Side Image */}
      <div className="image-content">
        <img src={whatWeOffer} alt="Financial Planning" />
      </div>
    </section>

      {/* Stats Section */}
      <div className="stats-section">
        <div className="stat-item">
          <img src={clients} alt="Clients Icon" />
          <h2>1000+</h2>
          <p>Clients</p>
        </div>
        <div className="stat-item">
          <img src={aum} alt="AUM Icon" />
          <h2>345+</h2>
          <p>Lacs AUM</p>
        </div>
        <div className="stat-item">
          <img src={experience} alt="Experience Icon" />
          <h2>10+</h2>
          <p>Years Experience</p>
        </div>
        <div className="stat-item">
          <img src={awards} alt="Awards Icon" />
          <h2>18+</h2>
          <p>Awards</p>
        </div>
      </div>

      {/* Our Team Section */}
      <div className="our-team">
        <h2>Our Team</h2>
        <div className="team-members">
          {/* Team Member 1 */}
          <div className="team-member">
            <img src={team_member_1} alt="Team Member 1" />
            <div className="member-info">
              <h3>Mr. Vikram Maheshwari</h3>
              <h6>Founder</h6>
              <p>
                Mr. Vikram Maheshwari is the esteemed Founder of Tax O Wealth,
                bringing over a decade of rich experience in the financial
                services industry. With an MBA in Business Analytics, Vikram is
                celebrated for his deep understanding of distribution practices
                and the challenges they present. His expertise and strategic
                insight have been instrumental in guiding Tax O Wealth towards
                innovative solutions and exceptional client service.
                <br />
                Under Vikram's leadership, Tax O Wealth has thrived, consistently delivering unparalleled value to our clients. His dedication to excellence and comprehensive knowledge of the financial landscape make him a cornerstone of our team and a trusted advisor to our clients.
              </p>
            </div>
          </div>

          {/* Team Member 2 */}
          <div className="team-member">
            <img src={team_member_2} alt="Team Member 2" />
            <div className="member-info">
              <h3>Mrs. Sonu Kabra</h3>
              <h6>Co-Founder</h6>
              <p>
                Mrs. Sonu Kabra is the visionary Co-Founder of Tax O Wealth,
                whose extensive expertise and innovative vision have been pivotal
                to the company's success. With a strong background in financial
                services, Sonu excels in identifying growth opportunities and
                streamlining distribution strategies.
                <br />
                Her collaborative approach and strategic mindset are integral to
                the firm’s mission of providing top-notch financial solutions.
                <br />
                Sonu’s unwavering commitment to client success and her ability to navigate complex financial landscapes have significantly contributed to expanding Tax O Wealth’s reach and impact. As a Co-Founder, she plays a crucial role in driving the company's growth and ensuring our clients receive the highest level of service and support.
              </p>
            </div>
          </div>

          {/* Team Member 3 */}
          <div className="team-member">
            <img src={team_member_3} alt="Team Member 3" />
            <div className="member-info">
              <h3>Ms. Anushka Kabra</h3>
              <h6>Financial Analyst</h6>
              <p>
                Ms. Anushka Kabra is the talented Financial Analyst at Tax O
                Wealth, known for her analytical acumen and detail-oriented
                approach. Anushka plays a key role in evaluating financial data,
                conducting market research, and developing strategic insights
                that drive our financial planning and decision-making processes.
                <br />
                With her sharp analytical skills and a keen eye for detail, Anushka ensures that our financial strategies are both sound and innovative. Her dedication to precision and her ability to interpret complex data sets make her an invaluable asset to the team, contributing significantly to the financial health and growth of Tax O Wealth.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsKnowMore;
